export default "__VITE_ASSET__Bb6tCLY5__"